<template>
  <div class="app-center-detail">
    <a-modal centered :width="884" v-model="visible" :title="appDetail.name" @cancel="hideModal">
      <a-spin :spinning="loading">
        <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />

        <div class="content">
          <div class="desc">{{ appDetail.description }}</div>
          <div class="app-pics flex-side-center">
            <div
              class="app-pic-item flex-column flex-side-center flex-auto"
              v-for="(series, index) in appSeries"
              :key="index">
              <img :src="series.imageUrl" :alt="series.imageName" />
              <span class="text">{{ series.imageName }}</span>
            </div>
          </div>
          <div class="trigger-action">
            <a-tabs :animated="false" v-model="tabKey" :tabBarGutter="32" :tabBarStyle="tabBarStyle">
              <a-tab-pane v-for="tab in tabs" :key="tab.key" :tab="tab.name">
                <div class="section">
                  <template v-if="triggerOrActions(tab.key).length">
                    <div
                      class="tab-item flex-column flex-main-between"
                      v-for="(item, idx) in triggerOrActions(tab.key)"
                      :key="idx">
                      <div class="title">{{ item.name }}</div>
                      <div class="desc">{{ item.description }}</div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="flex-center" style="height: 200px">
                      <a-empty :image="Empty.PRESENTED_IMAGE_SIMPLE" description="暂无数据" />
                    </div>
                  </template>
                </div>
              </a-tab-pane>
            </a-tabs>
          </div>
        </div>
      </a-spin>
      <!-- 自定义页脚为空 -->
      <template #footer></template>
    </a-modal>
  </div>
</template>

<script>
import { Empty } from 'ant-design-vue'
import { getAppDetail } from '@/api'

export default {
  name: 'AppDetail',
  data() {
    return {
      Empty,
      visible: false,
      loading: false,
      tabKey: 'triggers',
      appDetail: {},
      tabs: [
        { id: 1, key: 'triggers', name: '触发动作列表' },
        { id: 2, key: 'actions', name: '执行动作列表' },
      ],
      tabBarStyle: {
        color: '#626973',
        fontWeight: 500,
      },
    }
  },
  computed: {
    appSeries() {
      const { extInfo } = this.appDetail
      return extInfo?.images || []
    },
    triggerOrActions() {
      return (key) => {
        return this.appDetail[key] || []
      }
    },
  },
  methods: {
    async getAppDetail({ appId }) {
      try {
        this.loading = true
        const { code, data } = await getAppDetail({ appId })
        if (code === 0) {
          this.appDetail = data || {}
        }
      } catch (err) {
        console.error(err)
      } finally {
        this.loading = false
      }
    },
    showModal(app) {
      this.resetState()
      this.getAppDetail(app)
      this.visible = true
    },
    hideModal() {
      this.visible = false
      this.resetState()
    },
    resetState(tabKey = 'triggers') {
      this.tabKey = tabKey
      this.appDetail = {}
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .ant-modal-title {
  font-size: 26px !important;
  font-weight: 500 !important;
  color: $secondary-color !important;
}
::v-deep .ant-modal-header {
  padding: 32px 40px 16px !important;
  border: none !important;
}
::v-deep .ant-modal-body {
  padding: 0 40px 0 40px !important;
}
::v-deep .ant-modal-footer {
  padding: 16px 0 !important;
  border: none !important;
}
::v-deep .ant-modal-close {
  top: 14px !important;
  right: 20px !important;
}
::v-deep .ant-modal-close-x {
  color: #222 !important;
  font-size: 22px !important;
  font-weight: 500 !important;
}

::v-deep .ant-tabs-ink-bar {
  height: 4px !important;
  background-color: $primary-color !important;
}
::v-deep .ant-tabs-nav .ant-tabs-tab-active {
  color: $secondary-color !important;
}
::v-deep .ant-tabs-bar {
  border-bottom: none !important;
}
::v-deep .ant-tabs-nav .ant-tabs-tab {
  margin: 0 32px 0 0 !important;
  padding: 16px 0 10px 0 !important;
  font-size: $header-size !important;
}

.content {
  height: 556px;
  overflow-y: auto;
  .desc {
    color: #626973;
    line-height: 28px;
  }
  .app-pics {
    margin-top: 8px;
    border-bottom: 2px solid #e9eef4;
    overflow-x: auto;
    .app-pic-item {
      margin-bottom: 12px;
      img {
        width: 148px;
        height: 122px;
      }
      .text {
        @include fc(16px, 500, #333);
      }
    }
  }

  .trigger-action {
    .section {
      .tab-item {
        margin-bottom: 16px;
        padding: 24px 16px;
        background: #f4f7fc;
        border-radius: 4px;
        &:last-child {
          margin-bottom: 0;
        }
        .title {
          margin-bottom: 4px;
          @include fc(18px, 500, $secondary-color);
        }
        .desc {
          color: #626973;
        }
      }
    }
  }
}
</style>
